module.exports = __webpack_public_path__ + "static/img/tqzl.a1da903.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tqzl.png
// module id = LAq9
// module chunks = 8